import React from 'react';
import { useSelector } from 'react-redux';

function IconAndName() {
    const fullName = useSelector((user) => user.gas.info.customer_full_heading)
    const splittedName = fullName.split(' ').slice(0, -1).join(' ')
    const splittedNameLower = splittedName.toLowerCase()
    const username = useSelector((user) => user.gas.info.user_username)
    return (
        <div className="iconAndName">
            <div className="iconContainer">
                <img src={`https://avatars.dicebear.com/api/bottts/${splittedName}.svg`} alt="foto profilo" />
            </div>
            <div className="name">
                <p className='main'>Ciao {splittedNameLower}</p>
                <p className='secondary'>@{username}</p>
            </div>
        </div>
    );
}

export default IconAndName;
